import React, { useState, useEffect } from 'react';
import ButtonTabs from '../common/ButtonTabs';

import MediaList from './MediaList';

import HomeVodSkeleton from '../../components/skeleton/HomeVodSkeleton';

import { getData } from '../../constants/api_index';
import { Body } from '../../styles/homeStyles';
import { useHistory } from 'react-router-dom';

import _ from 'lodash';

const TAB = ['종합', '민물', '바다', '루어'];

const MainVodList = () => {
  const history = useHistory();
  const [tabValue, setTabvalue] = useState(1);
  const [vodList, setVodList] = useState([]);

  const [renderList, setRenderList] = useState([]);

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    getTabValue();
  }, []);

  useEffect(() => {
    let arr = [];

    if (vodList.length > 0) {
      vodList.map(v => {
        let ct = TAB[tabValue];
        if (ct === '루어') ct = '루어&플라이';

        if (v.category === ct) {
          arr.push(v);
        }
      });

      arr = _.cloneDeep(arr).filter((d, i) => {
        if (i <= 5) return d;
      });

      setRenderList(arr);
    }
  }, [tabValue, vodList]);

  const getDataList = () => {
    getData('program/recommend').then(res => {
      let arr = res?.value ? res?.value : [];

      arr.sort((a, b) => {
        return Number(a?.mainSortOrder) > Number(b?.mainSortOrder) ? 1 : -1;
      });

      setVodList(arr);
    });
  };

  const getTabValue = () => {
    getData('info').then(res => {
      if (res?.value && res?.value?.length > 0) {
        res?.value.map(ct => {
          if (ct?.id === 'main_category') {
            TAB?.map((tab, i) => {
              if (tab === ct?.name) {
                setTabvalue(i);
              }
            });
          }
        });
      }
    });
  };

  const handleCangeTab = e => {
    setTabvalue(e);
  };

  const goDetail = data => {
    history.push(process.env.PUBLIC_URL + `/vod-detail?id=${data.id}&tab=-1`);
  };

  return (
    <Body Pt={true}>
      <ButtonTabs title='절찬 방영중~' value={tabValue} tabList={TAB} rtValue={handleCangeTab} />
      {renderList.length > 0 ? (
        <MediaList list={renderList} type='rec-vod' mainShowCnt={2} playBtn={false} goDetail={goDetail} />
      ) : (
        <HomeVodSkeleton />
      )}
    </Body>
  );
};

export default MainVodList;
